export default [
    {
        path: '/user/messages',
        props: true,
        component: () => import('@/views/Message'),
    },
];
